// extracted by mini-css-extract-plugin
export default {"container":"p6d91gattZY2WxaB3Jb_","body":"yoOpEOGtR2JbcHZuBKkw"};